import { render, staticRenderFns } from "./PrimerComms.vue?vue&type=template&id=0680f1b3&scoped=true&"
import script from "./PrimerComms.vue?vue&type=script&lang=js&"
export * from "./PrimerComms.vue?vue&type=script&lang=js&"
import style0 from "./PrimerComms.vue?vue&type=style&index=0&id=0680f1b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0680f1b3",
  null
  
)

export default component.exports